import i18n from 'i18next';
import {reactI18nextModule} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector)
	.use(reactI18nextModule)
	.init({
		fallbackLng: 'de',

		resources: {
			de: {
				overview: {
					title: 'Übersicht',
					today: 'heute',
					tomorrow: 'beginnt morgen',
					done: 'erledigt - weiter so!',
					missed: 'verpasst',
					missed_joker: 'verpasst, Joker',
					missedRetryTitle:
						'Du warst dieses Mal leider nicht erfolgreich, weil du einen Trainingstag verpasst hast.',
					cheatedRetryTitle:
						'Du warst dieses Mal leider nicht erfolgreich, weil du versucht hast zu schummeln.',
					missedRetryDescription:
						'Gib nicht auf, auch wenn du diesmal die Fitnesswette nicht gewinnen konntest. Du erhältst eine neue Chance. Starte einfach von vorne und erhalte diesmal die Belohnungsauszahlung! Jeder erlebt einmal Rückschläge, Kopf hoch und viel Erfolg!',
					retry: 'Erneut versuchen',
					retryDialogTitle: 'Erneut versuchen?',
					retryDialogDescription:
						'Du hast die Möglichkeit die Fitnesswette neu zu starten. Bitte beachte, dass dein Fortschritt dabei auf Monat 1, Tag 1 zurückgesetzt wird. Dieser Vorgang kann nicht rückgängig gemacht werden.',
					payoutTitle:
						'Herzlichen Glückwunsch, echt starke Leistung!',
					payoutDescription:
						'Du hast die Fitnesswette gewonnen und kannst dich nun entscheiden, ob du auf Stufe 2 verlängern oder die Auszahlung von {{payoutAmount}} € erhalten möchtest. Beachte: Wenn du verlängerst, erhöht sich die mögliche Auszahlung um weitere {{increasedBy}} €. Die Gesamtauszahlung beträgt dann {{increasedAmount}} € in {{days}} Tagen. Entscheidest du dich jetzt für die Auszahlung, so beträgt die nächstmögliche Auszahlung wieder 50€ (Stufe 1). Je öfter du verlängerst, desto höher dein möglicher Gewinn!',
                    payoutDescriptionMaximum:
                        'WOW! Du hast die Fitnesswette gewonnen und den maximalen Auszahlungsbetrag von {{payoutAmount}} € erreicht. Bitte beantrage deine Auszahlung! Danach kannst du dein Programm gerne noch weiter verlängern.',
					workout: 'Training',
					workout_today: 'Offenes Training',
					rest_day: 'Ruhetag',
					locked: 'gesperrt',
					cheated: 'geschummelt',
					suspicious:
						'Unregelmäßigkeiten - Unser Team wird diesen Tag bei der Auszahlung nochmals genauer ansehen. Solange du trainiert hast, gibt es keinen Grund zur Sorge.',
					moreHour: 'Stunden übrig',
					moreMinute: 'Minuten übrig',
					day: 'Tag',
					extend: 'Kostenlos um 30 Tage verlängern',
					request_payment: 'Auszahlung beantragen',
					motivation_title: 'Du schaffst das!',
					invited_friends: 'Eingeladene Freunde',
					invite_bonus: 'Freunde Bonus',
					total: 'Gesamtauszahlung',
					open: 'Nächste Auszahlung in {{count}} Tag',
					payout: 'Nächstmögliche Auszahlung',
					nextPayout: '{{amount}} € Auszahlung in {{count}} Tag',
					nextPayout_plural:
						'{{amount}} € Auszahlung in {{count}} Tagen',
					friends:
						'Für jeden Freund, der mitmacht und keinen Tag verpasst, erhöhen wir deine Auszahlung um ',
					friends_amount: '20€',
					more_payout: 'Jetzt Freunde einladen',
					open_plural: 'Nächste Auszahlung in {{count}} Tagen',
					leftCellHeader: 'Monat',
					rightCellHeader: 'Nächstmögliche Auszahlung',
				},
				workout: {
					title: 'Training',
					begin: 'Nächste Übung',
					start: 'Übung starten',
					beginFirst: 'Training starten',
					end: 'Übung beenden',
					endWorkout: 'Training beenden',
					next: 'Nächste Übung',
					nextPause: 'Pause',
					finishPause: 'Pause beenden',
					time: 'Zeit',
					round: 'Runde',
					proposedPause: '30 Sek. Pause (empfohlen)',
					pauseText: 'Pause (empfohlen)',
					reallyQuit:
						'Möchtest du dein aktuelles Training wirklich abbrechen?',
					continue: 'Weiter trainieren',
					continueLater: 'Später fortsetzen',
					discard: 'Training abbrechen und Fortschritt löschen',
					errorTech:
						'Das Training kann nicht direkt aufgerufen werden. Bitte starte das Training über die Startseite: my.toplife.zone',
					askLeaveWorkout:
						'Möchtest du das Training wirklich beenden?',
					swipeButtonHelp:
						'Ziehe den blauen Teil des Buttons nach rechts und lasse diesen dort los.',
					submitWorkout: 'Übertrage Training',
					reps: 'WDH',
					secs: 'SEK',
					roundOf: 'Runde {{roundNumber}} von {{roundCount}}',
					excerciseNr: 'Übung {{excerciseNr}}',
					warmup: 'warmup',
					cooldown: 'cooldown',
					withOptionalWarmup: 'Optionales Warmup aktivieren',
					withOptionalCooldown: 'Optionales Cooldown aktivieren',
					goBack: 'Übung zurück',
					toneOff: 'Ton ausschalten',
					toneOn: 'Ton einschalten',
					closeTraining: 'Training verlassen',
					roundFinished: '{{round}} beendet!',
					toRound: 'zum {{round}}',
					warnBeforeWiping: 'Du hast dein Training heute bereits gestartet. Veränderst du die Einstellungen, verlierst du deinen heutigen Fortschritt und musst dein Training erneut beginnen. Möchtest du dennoch fortfahren?',
					doWipeSlateClean: 'Ja',
					dontWipeSlateClean: 'Nein',
					submitFailed: 'Dein Training konnte leider nicht gespeichert werden. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
				},
				survey: {
					title: 'Feedback',
				},
				profile: {
					title: 'Profil',
					change_level: 'Level ändern',
					request_payment: 'Auszahlung beantragen',
				},
				login: {
					title: 'Login',
					login_failed:
						'Login fehlgeschlagen, bitte überprüfe deine Zugangsdaten.',
					placeHolderMail: 'E-Mail',
					placeHolderPassword: 'Passwort',
				},
				level: {
					title: 'Level wählen',
					level1: 'Level 1',
					level1_description:
						'ALPHA-Challenge: Erstes Bodyweight-training (Keine Knieliegestütze, Keine Liegestütze)',
					level2: 'Level 2',
					level2_description:
						'BETA-Challenge: Wenig Erfahrung mit Bodyweight-training (Mit Knieliegestütze, ohne Liegestütze)',
					level3: 'Level 3',
					level3_description:
						'GAMMA-Challenge: Erfahrung mit Bodyweight-training (Mit Knieliegestütze, ohne Liegestütze)',
					level4: 'Level 4',
					level4_description:
						'DELTA-Challenge: Fortgeschritten (Mit Liegestütze, Mit Burpees)',
					level5: 'Level 5',
					level5_description:
						'EPSILON-Challenge: Profi - Maximale Intensität (Mit Liegestütze, Mit fortgeschrittenen Burpees)',
				},
				friends: {
					title: 'Fortschritt teilen',
					descriptionTitle: 'LIVE Fortschritt teilen',
					description:
						'Die beste Motivation: Freunde können die 30-Tage-Übersicht einsehen und damit mitverfolgen, wie du die Challenge erfolgreich absolvierst.',
					descriptionInfo:
						'Die Erfolgsquote der TeilnehmerInnen, die Ihren Fortschritt teilen, liegt bei über 95%.',
					hideShare: 'Diese Ansicht nicht mehr anzeigen.',
					shareFacebook: 'auf Facebook teilen',
					shareWhatsApp: 'auf WhatsApp teilen',
					shareEmail: 'via E-Mail teilen',
					skipShare: 'nicht jetzt',
				},
				info: {
					title: 'Toplife News',
					descriptionTitle:
						'Neues Design und neue Workouts in Kürze!',
					description:
						'In Kürze veröffentlichen wir ein komplett überarbeitetes Design, sowie neue Trainingspläne und Funktionen.',
				},
				rating: {
					title: 'Bewertung',
					descriptionTitle: 'Wie gefällt dir Toplife bisher?',
					commentTitle:
						'Toplife Community - Persönliche Anfrage an dich:',
					commentUsTitle:
						'Kommentiere bitte folgenden Post und erkläre was die Fitnesswette so besonders macht bzw. warum du sie weiterempfehlen würdest. DANKE für deine Unterstützung!',
					commentUsThanks: 'Dein Toplife Team',
					commentCta: 'Beitrag kommentieren',
				},
				success: {
					title: 'Yeah, gratuliere!',
					congratulationTitle: 'Gratuliere!',
					congratulationDescription:
						'Starke Leistung, du hast soeben 30 Tage erfolgreich absolviert und deinen Trainingsplan eingehalten. Weiter so!',
				},
				payoutSuccess: {
					title: 'Stark, du hast es geschafft!',
					congratulationTitle: 'Stark, du hast es geschafft!',
					congratulationDescription:
						'Herzliche Glückwünsche, du hast stahlharte Disziplin bewiesen und dein Training erfolgreich absolviert. Deine Auszahlung ist unterwegs.',
				},
				connect: {
					title: 'Mit Freunden trainieren',
					descriptionTitle: 'Du trainierst lieber im Team?',
					description:
						'Fordere Freunde heraus mitzumachen! Maximal 3 Personen erhalten durch deine Einladung einen kostenlosen Zugang.',
					descriptionInfo:
						'Die Erfolgsquote der TeilnehmerInnen, die gemeinsam trainieren, liegt bei über 95%.',
					hideShare: 'Diese Ansicht nicht mehr anzeigen.',
					shareFacebook: 'via Facebook einladen',
					shareWhatsApp: 'via WhatsApp einladen',
					shareEmail: 'via E-Mail einladen',
					shareLink: 'Deinen Einladungslink kopieren',
					skipShare: 'nicht jetzt',
					new: 'NEU:',
				},
				invite: {
					title: 'Lade deine Freunde ein',
					descriptionTitle: 'Lade deine Freunde ein',
					description:
						'Fordere Freunde heraus, um mitzumachen! Für jeden Freund der mitmacht und keinen Tag verpasst, erhöhen wir deine Auszahlung um ',
					friends_amount: '20€',
					descriptionInfo:
						'Die Erfolgsquote der TeilnehmerInnen, die gemeinsam trainieren, liegt bei über 95%.',
					hideShare: 'Diese Ansicht nicht mehr anzeigen.',
					shareFacebook: 'via Facebook einladen',
					shareWhatsApp: 'via WhatsApp einladen',
					shareEmail: 'via E-Mail einladen',
					shareLink: 'Deinen Einladungslink kopieren',
					skipShare: 'nicht jetzt',
					new: '+ 20€',
				},
				payout: {
					title: 'Auszahlung',
					subTitle: 'Kontodaten',
					titleDescription:
						'Bitte teile uns noch deinen IBAN mit, damit wir deine Auszahlung sicher auf dein Bankkonto durchführen können. Die Überweisung kann bis zu 7 Werktage in Anspruch nehmen.',
					requestPayout: 'Auszahlen',
					country: 'Land',
					zip: 'Postleitzahl',
					street: 'Adresse',
					city: 'Name der Stadt',
					phone: 'Telefonnummer',
					bankAccount: 'Kontonummer',
					failed:
						'Auszahlung fehlgeschlagen, bitte überprüfe deine Eingabe',
					notAllowed:
						'Du musst zuerst dein Training erfolgreich beenden, damit du deine Auszahlung erhalten kannst',
				},
				pause: {
					title: 'Krankmeldung oder Urlaub',
					subTitle: 'Krankmeldung oder Urlaub',
					titleDescription:
						'Mit dieser Funktion kannst du deine Fitnesswette pausieren ohne deinen ganzen Fortschritt zu verlieren. Bitte beachte, dass du mindestens 3 Tage bis maximal 30 Tage pausieren kannst. Dein aktuelles Monat wird zurückgesetzt und startet nach der Pause wieder bei Tag 1.',
					count: 'Länge der Pause in Tagen, ab heute',
					failed:
						'Bitte überprüfe deine Eingabe. Du kannst mindestens 3 Tage bis maximal 30 Tage pausieren.',
					notAllowed:
						'Leider hast du bereits mehr als einen Trainingstag verpasst. Gib nicht auf, auch wenn du diesmal die Fitnesswette nicht gewinnen konntest. In der Hauptansicht kannst du jederzeit erneut starten und von vorne beginnen.',
					notAllowedCheated:
						'Leider hast du geschummelt, dadurch steht dir diese Funktion aktuell nicht zur Verfügung.',
					notAllowedOld:
						'Leider hast du bereits mehr als zwei Trainingstage verpasst.',
					noPauseWhilePause: 'Dein Training ist bereits pausiert.',
					requestPause: 'Pause speichern',
				},
				common: {
					appName: 'Toplife',
					dismiss: 'Schließen',
					cancel: 'Abbrechen',
					shortLoading: 'App wird geladen, einen Augenblick bitte.',
					cell_failed: 'Keine Internetverbindung',
					currentLanguage: 'Die Sprache ist auf "{{lng}}" gesetzt',
					alreadyMissed: 'Du hast die Frist bereits verpasst.',
					logout: 'Abmelden',
					login: 'Anmelden',
					payout: 'Auszahlung',
					moveDays: 'Ruhetage verschieben',
					moveDaysCorrupted: 'Du versuchst, veraltete Tage zu verschieben. Bitte gehe zurück zur Übersicht und aktualisieren deine Tage.',
					forgotPassword: 'Passwort vergessen?',
					accountDisabledTitle: 'Account deaktiviert',
					accountDisableDescription:
						'Aktuell hast du keinen Wetteinsatz hinterlegt. Bitte hinterlege deinen Wetteinsatz um das Training zu starten.',
					activateAccount: 'Account jetzt aktivieren',
					noAccountJet: 'Du hast noch keinen Zugang?',
					accountInfo:
						'Du erhältst deine Zugangsdaten via E-Mail nach Hinterlegung des Wetteinsatzes.',
					register: 'Hier Fitnesswette starten',
					changeLevel: 'Level ändern',
					shortSec: 'Sek.',
					hour: '{{count}} Stunde',
					hour_plural: '{{count}} Stunden',
					minute: '{{count}} Minute',
					minute_plural: '{{count}} Minuten',
					save: 'Speichern',
					payoutSuccessful:
						'Respekt, du hast mit deiner Disziplin überzeugt! Herzlichen Glückwunsch zur absolvierten Challenge! Unser System überprüft nun deine Workouts. Die Auszahlung wird anschließend von unserer Finanzabteilung freigegeben.',
					payoutNotPossible:
						'Eine Auszahlung ist leider nicht möglich.',
					extendSuccessful:
						'Respekt, du hast mit deiner Disziplin überzeugt! Weiter so! Du kannst nun mit der nächsten Challenge beginnen',
					extendNotPossible:
						'Eine Verlängerung ist derzeit nicht möglich.',
					askPayout:
						'Um kontinuierlich Erfolge zu erzielen, empfiehlt es sich dein Training fortzusetzen. Du kannst die Challenge kostenlos um weitere 30 Tage verlängern.',
					dontPayout: 'Fitnesswette verlängern',
					doPayout: 'Auszahlen',
					registerHere: 'Hier registrieren',
					registerDescription:
						'Das Trainingsprogramm mit maximaler Motivation erhältst du auf der Website von Toplife',
					shareTo: 'Fortschritt teilen',
					connectWithFriends: 'Mit Freunden trainieren',
					linkCopied:
						'Dein Einladungslink wurde in die Zwischenablage kopiert. Du kannst ihn nun beliebig einfügen (z.B. SMS, Messenger,...)',
					next: 'Weiter',
					pause: 'Krankmeldung / Urlaub',
                    month: 'MONATE',
                    yourPayout: 'Deine Auszahlung',
                    daysLeft: 'NOCH {{count}} TAG',
                    daysLeft_plural: 'NOCH {{count}} TAGE',
                    of: 'von'
				},
				howWasIt: {
					title: 'Wie war dein Training?',
					easy: 'zu leicht',
					medium: 'perfekt',
					hard: 'zu schwer',
					description:
						'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad doloremque sint delectus minus maxime. Excepturi ea placeat et distinctio. Ullam maiores amet laborum vitae ipsam beatae eum obcaecati illo voluptatem, modi error saepe quis enim nostrum temporibus delectus nobis! Voluptatum at alias porro! Ut consequatur illum tempore deleniti beatae dolores maiores obcaecati eius? Laudantium, facilis quam debitis error ullam provident.',
				},
				milestone: {
					title: 'Stark, du hast es geschafft!',
					dayDesc:
						'Herzliche Glückwünsche, du hast stahlharte Disziplin bewiesen und dein Training erfolgreich absolviert.',
					monthDesc:
						'Herzliche Glückwünsche, du hast stahlharte Disziplin bewiesen und dein Training erfolgreich absolviert.',
					payoutDesc:
						'Herzliche Glückwünsche, du hast stahlharte Disziplin bewiesen und dein Training erfolgreich absolviert. Deine Auszahlung ist unterwegs.',
				},
				upgrade: {
					title: 'Update',
					description:
						'Bitte aktualisiere die Anwendung, indem du diese Seite neu lädst oder den Button "Jetzt aktualisieren" klickst.',
					reload: 'Jetzt aktualisieren',
				},
				wallet:{
                    title: 'Deine Geldbörse',
                    description: 'Hier kannst du LIVE mitverfolgen, wie viel Geld du durch dein Training verdient hast. Die nächste Auszahlungsmöglichkeit liegt bei {{payoutAmount}}.',
					chartLabel: 'Gewinn'
				}
			},
            en: {
                overview: {
                    title: 'Overview',
                    today: 'today',
                    tomorrow: 'starts tomorrow',
                    done: 'done - keep it up!',
                    missed: 'missed',
                    missed_joker: 'missed, Joker',
                    missedRetryTitle:
                        'You did not succeed this time because you missed a workout day.',
                    cheatedRetryTitle:
                        'You did not succeed this time because you tried to cheat.',
                    missedRetryDescription:
                        'Do not give up, just because you did not win the fitness bet this time. There is a new chance. Just start from the beginning and receive the reward payout this time! Everybody experiences setbacks, keep your chin up and good luck!',
                    retry: 'Try again',
                    retryDialogTitle: 'Try again?',
                    retryDialogDescription:
                        'You have the option to restart the fitness bet. Please note that this will reset your progress to month 1, day 1. This process cannot be undone.',
                    payoutTitle:
                        'Congratulations, what great effort!',
                    payoutDescription:
                        'You have won the fitness bet and can decide whether you want to continue with Level 2 or to receive the payout of €{{payoutAmount}}. Pleas note: If you continue, the possible payout will increase by another €{{increasedBy}}. The total payout will be €{{increasedAmount}} in {{days}} days. If you opt for the payout now, the next possible payout will again be €50 (Level 1). The more often you continue, the higher your possible winnings!',
                    payoutDescriptionMaximum: 'WOW! You have won the fitness bet and reached the maximum payout amount of €{{payoutAmount}}. Please request your payout! After that you are welcome to extend your program.',
					workout: 'Workout',
                    workout_today: 'Pending workout',
                    rest_day: 'Rest day',
                    locked: 'locked',
                    cheated: 'cheated',
                    suspicious:
                        'Irregularities - Our team will take a closer look at this day upon payout. There is nothing to worry about as long as you have trained.',
                    moreHour: 'Hours left',
                    moreMinute: 'Minutes left',
                    day: 'Day',
                    extend: 'Extend for 30 days free of charge',
                    request_payment: 'Request payment',
                    motivation_title: 'You can do it!',
                    invited_friends: 'Invited friends',
                    invite_bonus: 'Friend bonus',
                    total: 'Total payout',
                    open: 'Next payout in {{count}} day',
                    payout: 'Next possible payout',
                    nextPayout: '€{{amount}} payout in {{count}} day',
                    nextPayout_plural:
                        '€{{amount}} payout in {{count}} days',
                    friends:
                        'For every friend who participates and does not miss a day, we increase your payout by ',
                    friends_amount: '€20',
                    more_payout: 'Invite friends now',
                    open_plural: 'Next payout in {{count}} days',
                    leftCellHeader: 'Month',
                    rightCellHeader: 'Next possible payout',
                },
                workout: {
                    title: 'Workout',
                    begin: 'Next exercise',
                    start: 'Start exercise',
                    beginFirst: 'Start workout',
                    end: 'End exercise',
                    endWorkout: 'End workout',
                    next: 'Next exercise',
                    nextPause: 'Pause',
                    finishPause: 'End pause',
                    time: 'Time',
                    round: 'Round',
                    proposedPause: '30-second break (recommended)',
                    pauseText: 'Pause (recommended)',
                    reallyQuit:
                        'Do you really want to cancel your current workout?',
                    continue: 'Continue workout',
                    continueLater: 'Continue later',
                    discard: 'Cancel training and delete progress',
                    errorTech:
                        'The training cannot be accessed directly. Please start the training via the homepage: my.toplife.zone',
                    askLeaveWorkout:
                        'Do you really want to leave the workout?',
                    swipeButtonHelp:
                        'Drag the blue part of the button to the right and release it.',
                    submitWorkout: 'Submit workout',
                    reps: 'REPS',
                    secs: 'SEC',
                    roundOf: 'Round {{roundNumber}} of {{roundCount}}',
                    excerciseNr: 'Exercise {{excerciseNr}}',
                    warmup: 'Warmup',
                    cooldown: 'Cooldown',
                    withOptionalWarmup: 'Activate optional warmup',
                    withOptionalCooldown: 'Activate optional cooldown',
                    goBack: 'Last exercise',
                    toneOff: 'Turn off sound',
                    toneOn: 'Turn on sound',
                    closeTraining: 'Leave workout',
                    roundFinished: '{{round}} finished!',
                    toRound: 'to {{round}}',
                    warnBeforeWiping: 'You have already started your training today. If you change the settings, you will lose your progress of today and have to start your training again. Do you still want to continue?',
                    doWipeSlateClean: 'Yes',
                    dontWipeSlateClean: 'No',
                    submitFailed: 'Unfortunately, your training could not be saved. Please check your internet connection and try again.',
                },
                survey: {
                    title: 'Feedback',
                },
                profile: {
                    title: 'Profile',
                    change_level: 'Change level',
                    request_payment: 'Request payment',
                },
                login: {
                    title: 'Login',
                    login_failed:
                        'Login failed, please check your login details.',
                    placeHolderMail: 'Email',
                    placeHolderPassword: 'Password',
                },
                level: {
                    title: 'Choose level',
                    level1: 'Level 1',
                    level1_description:
                        'ALPHA Challenge: First bodyweight workout (no knee push-ups, no push-ups)',
                    level2: 'Level 2',
                    level2_description:
                        'BETA Challenge: Little experience with bodyweight training (with knee push-ups, without push-ups)',
                    level3: 'Level 3',
                    level3_description:
                        'GAMMA Challenge: Experience with bodyweight training (with knee push-ups, without push-ups)',
                    level4: 'Level 4',
                    level4_description:
                        'DELTA Challenge: Advanced (with push-ups, with burpees)',
                    level5: 'Level 5',
                    level5_description:
                        'EPSILON Challenge: Expert - High Intensity (with push-ups, with advanced burpees)',
                },
                friends: {
                    title: 'Share progress',
                    descriptionTitle: 'Share LIVE progress',
                    description:
                        'The best motivation: Friends can view the 30-day overview and follow you as you successfully complete the challenge.',
                    descriptionInfo:
                        'The success rate of participants who share their progress is over 95%.',
                    hideShare: 'Hide this view.',
                    shareFacebook: 'Share on Facebook',
                    shareWhatsApp: 'Share on WhatsApp',
                    shareEmail: 'Share via email',
                    skipShare: 'noe now',
                },
                info: {
                    title: 'Toplife News',
                    descriptionTitle:
                        'New design and new workouts coming soon!',
                    description:
                        'Soon we will launch a fully updated design, as well as new workout plans and features.',
                },
                rating: {
                    title: 'Rating',
                    descriptionTitle: 'How do you like Toplife so far?',
                    commentTitle:
                        'Toplife Community - a personal request:',
                    commentUsTitle:
                        'comment on the following post and explain what makes the fitness bet so special or why you would recommend it. THANK YOU for your support!',
                    commentUsThanks: 'Your Toplife Team',
                    commentCta: 'Comment on this post',
                },
                success: {
                    title: 'Yeah, congratulations!',
                    congratulationTitle: 'Congratulations!',
                    congratulationDescription:
                        'Excellent performance! You have just successfully completed 30-day workout and followed your workout plan. Way to go!',
                },
                payoutSuccess: {
                    title: 'Awesome, you did it!',
                    congratulationTitle: 'Awesome, you did it!',
                    congratulationDescription:
                        'Congratulations, you have shown stern discipline and successfully completed your workout. Your reward is on its way.',
                },
                connect: {
                    title: 'Exercise with friends',
                    descriptionTitle: 'Would you rather train as a team?',
                    description:
                        'Challenge friends to join you! Up to 3 people will receive free access through your invitation.',
                    descriptionInfo:
                        'The success rate of the participants who train together is over 95%.',
                    hideShare: 'Hide this view.',
                    shareFacebook: 'Invite via Facebook',
                    shareWhatsApp: 'Invite via WhatsApp',
                    shareEmail: 'Invite via email',
                    shareLink: 'Copy your invitation link',
                    skipShare: 'not now',
                    new: 'NEW:',
                },
                invite: {
                    title: 'Invite your friends',
                    descriptionTitle: 'Invite your friends',
                    description:
                        'Challenge friends to join you! For every friend who participates and does not miss a day, we increase your payout by ',
                    friends_amount: '€20',
                    descriptionInfo:
                        'The success rate of the participants who train together is over 95%.',
                    hideShare: 'Hide this view.',
                    shareFacebook: 'Invite via Facebook',
                    shareWhatsApp: 'Invite via WhatsApp',
                    shareEmail: 'Invite via email',
                    shareLink: 'Copy your invitation link',
                    skipShare: 'not now',
                    new: '+ €20',
                },
                payout: {
                    title: 'Payout',
                    subTitle: 'Bank details',
                    titleDescription:
                        'Please provide us with your IBAN so that we can securely transfer your payment to your bank account. The transfer can take up to 7 business days.',
                    requestPayout: 'Payout',
                    country: 'Country',
                    zip: 'ZIP',
                    street: 'Address',
                    city: 'City',
                    phone: 'Phone number',
                    bankAccount: 'Bank account number',
                    failed:
                        'Withdrawal failed, please check your entry',
                    notAllowed:
                        'You must first successfully complete your training in order to receive a payout',
                },
                pause: {
                    title: 'Sick leave or vacation',
                    subTitle: 'Sick leave or vacation',
                    titleDescription:
                        'With this feature you can pause your fitness bet without losing all your progress. Please note that you can pause for a minimum of 3 days and a maximum of 30 days. Your current month will be reset and will start from day 1 after the pause.',
                    count: 'Duration of the pause in days, starting today',
                    failed:
                        'Please check your entry. You can pause for a minimum of 3 days and a maximum of 30 days.',
                    notAllowed:
                        'Unfortunately, you have already missed more than one training day. Do not give up just because you did not win the fitness bet this time. You can always restart it from the main page.',
                    notAllowedCheated:
                        'Sorry, you cheated, which means that this function is currently not available to you.',
                    notAllowedOld:
                        'Unfortunately, you have already missed more than two training days.',
                    noPauseWhilePause: 'Your training is already paused.',
                    requestPause: 'Save pause',
                },
                wallet:{
                    title: 'Your Wallet',
                    description: 'Here you can track LIVE how much money you have earned through your training. Next withdraw is possible at {{payoutAmount}}.',
                    chartLabel: 'Profit'
                },

                common: {
                    appName: 'Toplife',
                    dismiss: 'Close',
                    cancel: 'Cancel',
                    shortLoading: 'Loading app, one moment please.',
                    cell_failed: 'No Internet connection',
                    currentLanguage: 'The language is set to "{{lng}}"',
                    alreadyMissed: 'You have already missed the deadline.',
                    logout: 'Logout',
                    login: 'Login',
                    payout: 'Payout',
					moveDays: 'Move rest days',
					moveDaysCorrupted: 'You are trying to move outdated days. Please go back to overview and refresh days.',
                    forgotPassword: 'Forgot password?',
                    accountDisabledTitle: 'Account deactivated',
                    accountDisableDescription:
                        'You have not placed any bets at this time.  Please place your bet to start the training.',
                    activateAccount: 'Activate account now',
                    noAccountJet: 'You do not have access yet?',
                    accountInfo:
                        'You will receive your access data via email after placing your bet.',
                    register: 'Start fitness bet here',
                    changeLevel: 'Change level',
                    shortSec: 'Sec.',
                    hour: '{{count}} hour',
                    hour_plural: '{{count}} hours',
                    minute: '{{count}} minute',
                    minute_plural: '{{count}} minutes',
                    save: 'Save',
                    payoutSuccessful:
                        'Respect, your discipline is impressive!  Congratulations on completing the challenge! Our system will now check your workouts. Our finance department will then release the payout.',
                    payoutNotPossible:
                        'Unfortunately, a payout is not possible.',
                    extendSuccessful:
                        'Respect, your discipline is impressive!  Keep up the good work! You can now start the next challenge',
                    extendNotPossible:
                        'An extension is currently not possible.',
                    askPayout:
                        'In order to achieve continuous success, it is recommended to keep up your training. You can extend the challenge for another 30 days free of charge.',
                    dontPayout: 'Extend fitness bet',
                    doPayout: 'Payout',
                    registerHere: 'Register here',
                    registerDescription:
                        'The training program with maximum motivation is available on the Toplife website',
                    shareTo: 'Fortschritt teilen',
                    connectWithFriends: 'Share progress',
                    linkCopied:
                        'Your invitation link has been copied to the clipboard. You can now paste it to, e.g., text messages, messenger, etc.',
                    next: 'Next',
                    pause: 'Sick leave/Vacation',
					month: 'MONTHS',
					yourPayout: 'Your Payout',
                    daysLeft: '{{count}} DAY LEFT',
                    daysLeft_plural: '{{count}} DAYS LEFT',
					of: 'of'
                },
                howWasIt: {
                    title: 'How was your training?',
                    easy: 'too easy',
                    medium: 'perfect',
                    hard: 'too hard',
                    description:
                        'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad doloremque sint delectus minus maxime. Excepturi ea placeat et distinctio. Ullam maiores amet laborum vitae ipsam beatae eum obcaecati illo voluptatem, modi error saepe quis enim nostrum temporibus delectus nobis! Voluptatum at alias porro! Ut consequatur illum tempore deleniti beatae dolores maiores obcaecati eius? Laudantium, facilis quam debitis error ullam provident.',
                },
                milestone: {
                    title: 'Awesome, you did it!',
                    dayDesc:
                        'Congratulations, you have shown stern discipline and successfully completed your workout.',
                    monthDesc:
                        'Congratulations, you have shown stern discipline and successfully completed your workout.',
                    payoutDesc:
                        'Congratulations, you have shown stern discipline and successfully completed your workout. Your payout is on its way.',
                },
                upgrade: {
                    title: 'Update',
                    description:
                        'Please refresh the application by reloading this page or by clicking the "Refresh Now" button.',
                    reload: 'Refresh now',
                },
            },
		},

		// have a common namespace used around the full app
		ns: ['common'],
		defaultNS: 'common',

		debug: false,

		// cache: {
		//   enabled: true
		// },

		interpolation: {
			escapeValue: false, // not needed for react as it does escape per default to prevent xss!
		},
	});

export default i18n;



// WEBPACK FOOTER //
// ./src/utils/i18n.js